import { useQuery } from '@apollo/client';
import { NavigationStyles } from '@generated/graphql';
import { InlineImage } from '@ovComponents/2-component/inlineImage/inlineImage';
import { UserContext } from '@providers/userContextProvider';
import { entityInitials } from '@utils/common';
import { Avatar as HephaestusAvatar, useTheme } from 'hephaestus/web';
import { useContext } from 'react';
import { APP_BAR_AVATAR_ME } from './avatar.query';

export const Avatar = () => {
  const theme = useTheme();
  const { userContext, activeEntity } = useContext(UserContext);
  const { data, loading } = useQuery(APP_BAR_AVATAR_ME);

  const isUnifiedClientExperience =
    userContext.role?.navigationStyle === NavigationStyles.Simple;

  if (loading) {
    return <HephaestusAvatar.Skeleton size='xsmall' />;
  }

  const me = data?.me;

  return (
    <HephaestusAvatar
      size='xsmall'
      sx={{
        color: theme.component?.entityMenu?.avatar?.foregroundColor,
        backgroundColor: theme.component?.entityMenu?.avatar?.backgroundColor,
      }}
    >
      {me?.avatar ? (
        <InlineImage
          fileDocumentId={me.avatar}
          style={{ objectFit: 'cover', height: '100%' }}
        />
      ) : (
        (isUnifiedClientExperience && activeEntity
          ? (entityInitials(activeEntity) ?? '')
          : `${me?.firstName?.[0] ?? ''}${me?.lastName?.[0] ?? ''}`
        ).toUpperCase()
      )}
    </HephaestusAvatar>
  );
};
